import { render } from "./Media.vue?vue&type=template&id=55317e4a"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=55317e4a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__